"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CheckoutBillingAddressPlaceholder = function () {
    return (React.createElement("div", { className: "module", "data-placeholder-rows": true },
        React.createElement("ul", { className: "actionable-rows" },
            React.createElement("li", { className: "actionable-row actionable-row--placeholder" },
                React.createElement("div", { className: "actionable-row__content" })),
            React.createElement("li", { className: "actionable-row actionable-row--placeholder" },
                React.createElement("div", { className: "actionable-row__content" })))));
};
exports.default = CheckoutBillingAddressPlaceholder;
//# sourceMappingURL=checkout_billing_address_placeholder.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/checkout_billing_address_placeholder.js
// module id = 4ryS
// module chunks = 20 21 22